import React from 'react';

import Hero from '@components/Hero/Hero';
import ImageAboveFold from '@components/ImageAboveFold/ImageAboveFold';
import SubNav from '@components/SubNav/SubNav';
import { GatsbyImage } from "gatsby-plugin-image"
import { getImgixImageData } from "@utils";

import {
  IntegrationPageHeroDIV,
} from './IntegrationPageHero.styles';

const IntegrationPageHero = ({
  title,
  subtitle,
  slug,
  permalink,
  isFeatured,
  image,
}) => (
  <Hero style={{ overflow: 'visible', paddingTop: '0' }}>
    <IntegrationPageHeroDIV>
      <SubNav
        hideSearch
        isHierarchical
        items={[
          {
            link: '/help-desk-integration/',
            slug: 'help-desk-integration',
            title: 'Integrations',
            useAnchorTag: false,
          },
          {
            link: permalink,
            slug,
            title,
            useAnchorTag: false,
          },
        ]}
      />
      <div className="container">
        <figure>
          <ImageAboveFold
            alt=""
            aspectRatio={2.55}
            role="presentation"
            src="/images/pages/help-desk-integration/integrations--hero--cards.png"
            width={572}
          />
          {image && (
            // TODO: debug ImageAboveFold component here. Image is broken on prod.
            <ImageAboveFold
              alt={title}
              aspectRatio={isFeatured ? 148 / 80 : 1}
              className={isFeatured ? 'is-featured' : undefined}
              imageData={image.imgixImage?.gatsbyImageData}
              src={image.imgixImage.url}
              width={isFeatured ? 148 : 70}
            />
          )}
        </figure>
        <h1 className="font--display-S">Integrate {title} with Help&nbsp;Scout</h1>
        <p className="font--blockquote-S" style={{ marginBottom: 0 }}>{subtitle}</p>
      </div>
    </IntegrationPageHeroDIV>
  </Hero>
);

export default IntegrationPageHero;
